import { get, set } from "idb-keyval";
import { useCallback, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import instance from "./helpers/instance";
import axios from "axios";
import { useHistory } from "react-router-dom";
import useCustomModal from "components/CustomConfirm";
import CustomConfirmDialog from "components/CustomConfirm/CustomConfirmDialog";
import { Typography } from "@material-ui/core";
import { filterNonNull, personNameFull } from "util/format";
import { useConfirm } from "material-ui-confirm";
import { useState } from "util/stateref";
import moment from "moment-timezone";
import { useTrackEvent } from "util/trackEvent";
import { useAnalytics } from "@zennya/web-component-library/src";
import { activeUserState, analyticsIdentifierState, chatAttachmentState, chatChannelState, medicalChatChannelState, openChatState, SUPPORT_CHAT } from "pages/CustomerBooking";
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { toast } from "react-hot-toast";
import { serializeError } from "serialize-error";
import { useCreateBooking } from "pages/CustomerBookingCreate/createHook";
import { STEP_SIGN_IN } from "pages/CustomerBookingCreate/constants";
import { fingerprintState } from "util/deviceUUID";
const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

const testLogEventWhitelabel = async (request_id, medium, action) => {
  return (await instance.post(`${API_URL}/api/1/whitelabel/bookings/log_event`, {
    request_id,
    medium: medium ?? 'WEB',
    action
  }))
}

const requestPinCode = async (clientId) => {
  return (await instance.post(`${API_URL}/api/1/clients/${clientId}/code`))
    ?.data;
};

const requestWhitelabelVerification = async (customerId, bookingId) => {
  return (await instance.post(`${API_URL}/api/1/whitelabel/customers/validations/booking/request`, {
    booking_id: bookingId
  }))?.data;
}

const requestWhitelabelCustomerValidation = async ({ customerId, clientId, code }) => {
  const parseDate = moment.utc(code, 'MMDDYYYY')?.format('YYYY-MM-DD')
  return (await instance.post(`${API_URL}/api/1/whitelabel/customers/${customerId}/validate`, {
    client: clientId,
    birth_date: parseDate,
  }))?.data
}

const getPersonalInfo = async (clientId) => {
  const result = (await axios.get(`${API_URL}/api/1/personal_infos/${clientId}`))?.data;
  return result
}


const useUserState = (onLogout) => {
  const history = useHistory();
  const [user, setUser] = useState(undefined);

  const { identifyUsingIdAndTraitsV1, reset, fullReset, aliasTo, aliasToV1, identifyUsingIdAndTraits } = useAnalytics()

  const setChannelState = useSetRecoilState(chatChannelState);
  const setMedicalChannelState = useSetRecoilState(medicalChatChannelState);
  const setActiveUser = useSetRecoilState(activeUserState);
  const setChatOpen = useSetRecoilState(openChatState);
  const setChatAttachmentState = useSetRecoilState(chatAttachmentState);

  const resetFingerprint = useResetRecoilState(fingerprintState)
  const [fingerprint, setFingerprint]= useRecoilState(fingerprintState);
  
  const confirm = useCustomModal();

  const trackEvent = useTrackEvent()

  const fetchUser = useCallback(async (bookingId, validate = false) => {
    let usr = JSON.parse(localStorage.getItem('user'))
    if (!usr) {
      setUser(usr);
      return usr
    }
    if (validate) {
      try {
        const newUser = await getIdentity(usr?.client?.id || usr?.user?.id)
        const newPersonalInfo = await getPersonalInfo(usr?.client?.id || usr?.user?.id)
        usr = usr?.client?.id ? {...usr, client:newUser, personalInfo:newPersonalInfo?.info } : {...usr, user:newUser, personalInfo:newPersonalInfo }
      } catch (e) {
        showIdentError({ bookingId, error: e })
      } finally {
        setUser(usr);
        await localStorage.setItem('user', JSON.stringify(usr))
        return usr;
      }
    } else {
      setUser(usr);
      setActiveUser(usr)
      return usr;

    }

  }, []);

  useEffect(() => {
    fetchUser();
  }, []);

  const isAuthenticated = useCallback(
    async () => {
      return JSON.parse(localStorage.getItem('user'))
    },
    [],
  );
  const getIdentity = useCallback(async (clientId) => {
    const result = (await axios.get(`${API_URL}/api/1/clients/${clientId}`))?.data;
    return result;
  }, [])

  const segmentLogin = useCallback(async (clientId) => {
    // await aliasToV1(clientId, false)
    const ident = await getIdentity(clientId)
    await identifyUsingIdAndTraits(clientId, {
      $distinct_id: clientId,
      id: clientId,
      email: ident?.email,
      name: personNameFull(ident)
    })
  }, [])

  const segmentLoginAnonymous = useCallback(async () => {
    await identifyUsingIdAndTraits(null, {})
  }, [])

  const loginPinCode = useCallback(async ({ clientId, identifier, code, fingerprint }) => {
    const result = (
      await instance.post(`${API_URL}/api/1/clients/${clientId}/login`, {
        identifier,
        code,
        device_id: fingerprint,
      })
    )?.data;
    await localStorage.setItem('user', JSON.stringify(result))

    // await segmentLogin(result?.user?.id)
    return result;
  }, []);

  const loginPinCodeWithoutClient = useCallback(async ({ identifier, code, fingerprint }) => {
    const result = (
      await instance.post(`${API_URL}/api/1/clients/login/code`, {
        identifier,
        code,
        device_id: fingerprint,
      })
    )?.data;
    await localStorage.setItem('user', JSON.stringify(result))
    // await segmentLogin(result?.user?.id)
    return result;
  }, []);

  const [analyticsIdentifier, setAnalyticsIdentifier] = useRecoilState(analyticsIdentifierState);

  const doLogout = useCallback(async (bookingId, reload) => {
    setUser(undefined);
    setActiveUser(undefined)
    setChannelState()
    setMedicalChannelState()
    // await reset()
    window?.mixpanel?.cookie?.clear();  //gotcha with mixpanel.  segment.reset() DOESNT send mixpanel.reset()
    setAnalyticsIdentifier(false)

    await localStorage.removeItem("user");
    await localStorage.removeItem("defaultPaymentMethod");
    await localStorage.removeItem("storedMedicalPin")
    // await set("user", undefined);
    // await set("defaultPaymentMethod", undefined);
    // await set("storedMedicalPin", undefined)
    // await sessionStorage.clear()
    await setFingerprint(uuidv4());
    // await segmentLoginAnonymous()
    if (onLogout) {
      onLogout()
      return
    }
    if (reload) {
      history.replace('/bookings/login/' + bookingId + history.location.search);
      location.reload()
    }
  }, [history]);

  const showIdentError = useCallback(
    ({ title, params, bookingId, error }) => {
      confirm(props => (
        <CustomConfirmDialog {...props}
          description={params?.description ?? (<Typography>There was a problem with viewing your {bookingId?'booking':'info'}.  You can logout to try again or contact support</Typography>)}
          title={title}
          onConfirm={async () => {
            await trackEvent(`${title} - Error- Logout`, {})
            props.onClose()
            await doLogout(bookingId, true);
          }}
          onCancel={() => {
            trackEvent(`${title} - Error - Contact Support`, {})
            setChatOpen(SUPPORT_CHAT)
            setChatAttachmentState({ error, bookingId })
          }}
          onClose={null}
          cancellationText={params?.cancellationText ?? 'Contact Support'}
          confirmationText={params?.confirmationText ?? 'Logout'}
        />
      ))
    },
    [],
  );

  const showInvalidBookingError = useCallback(
    ({ title, params, bookingId, error }) => {
      confirm(props => (
        <CustomConfirmDialog {...props}
          description={<Typography>There was a problem with viewing your booking</Typography>}
          title={title}
          onConfirm={async () => {
            trackEvent(`${title} - Error - Contact Support`, {})
            setChatOpen(SUPPORT_CHAT)
            setChatAttachmentState({ error, bookingId })
          }}
          onClose={null}
          confirmationText={params?.cancellationText ?? 'Contact Support'}
          noCancel
        />
      ))
    },
    [],
  );

  const fetchBookingByAuth = useCallback(
    async (codeId, analyticsIdentifier) => {
      try {
        const data = (await axios.get(`${API_URL}/api/1/bookings/${codeId}/auth`))?.data;
        if (!analyticsIdentifier) {
          const clientId = data?.client?.id
          if (!clientId) {
            return data
          }
          const profile = filterNonNull({
            email: data?.white_label_customer?.email ?? data?.client?.email,
            name: data?.white_label_customer ? personNameFull(data?.white_label_customer) : data?.client?.last_name ? personNameFull(data?.client) : undefined
          })
          const payload = {
            id: clientId,
            // $id: clientId,
            // $distinct_id: clientId,
            ...profile
          }
          await identifyUsingIdAndTraits(clientId, payload)
          return data
        }
        return data
      } catch (e) {
        if (e?.response?.data?.details === 'You are unauthorized to make this request' && e?.response?.status === 401) {
          history.push(STEP_SIGN_IN + "?bookingId=" + codeId)
          window?.location?.reload()
          return null
        } else {
          showInvalidBookingError({ title: 'Invalid Booking', bookingId: codeId, error: serializeError(e) })
          return null
        }
      }
    },
    [],
  );

  const logout = useCallback(async (bookingId, params, onOpenChat = () => { }, forceOpen = false) => {
    const user = JSON.parse(localStorage.getItem('user'))
    let error = null
    let ident
    try {
      ident = await getIdentity(user?.client?.id || user?.user?.id)
    } catch (e) {
      error = e
      // await doLogout(bookingId);
      // return
    }

    const title = params?.title ?? 'Logout'
    if (ident) {
      try {
        confirm(props => {
          const { onClose, ...rest } = props
          const mappedProps = filterNonNull({
            ...rest,
            onClose: forceOpen ? null : onClose
          })
          return (
            <CustomConfirmDialog {...mappedProps}
              description={params?.description ?? (<Typography>Are you sure you want to log out of this account?<br />You are currently logged in as {personNameFull(ident)} with email {ident?.email} </Typography>)}
              title={title}
              onConfirm={async () => {
                await trackEvent(`${title} - Logout`, { ident: ident?.id, email: ident?.email })
                onClose()
                await doLogout(bookingId, true);
              }}
              onCancel={() => {
                trackEvent(`${title} - Cancel`, { ident: ident?.id, email: ident?.email })
              }}
              cancellationText={params?.cancellationText ?? 'Cancel'}
              confirmationText={params?.confirmationText ?? 'Logout'}
            />
          )
        })
      } catch (e) {
      }
    } else {
      showIdentError({ title, params, bookingId, error })
    }


  }, [confirm, doLogout, fetchUser, getIdentity])


  return { doLogout, isAuthenticated, fetchBookingByAuth, user, getUser: fetchUser, logout, loginPinCode, getIdentity, loginPinCodeWithoutClient, segmentLoginAnonymous };
};

const clientLogin = async ({ email, password, fingerprint }) => {
  const result = (
    await instance.post(`${API_URL}/api/1/clients/login`, {
      email,
      password,
      device_id: fingerprint,
    })
  )?.data;
  
  await localStorage.setItem('user', JSON.stringify(result))
  const newPersonalInfo = await getPersonalInfo(result?.client?.id)
  const user = {
    ...result,
    personalInfo: newPersonalInfo?.info
  }
  await localStorage.setItem('user', JSON.stringify(user))
  return result;
}

const clientRegister = async ({
  email, first_name, last_name, password, device_id
}) => {
  const result = (
    await instance.post(`${API_URL}/api/1/clients/register`, {
      device_type: 'web',
      device_id,
      email,
      first_name,
      last_name,
      password,
    })
  )?.data;
  await localStorage.setItem('user', JSON.stringify(result))
  return result;
}

const requestMobileNumberValidationCode = async ({ number }) => {
  const result = (
    await axios.post(`${API_URL}/api/1/clients/numbers/validate`, {
      number
    })
  )?.data?.code
}


const validateMobilePhoneNumber = async ({ number, code }) => {
  const result = (
    await axios.put(`${API_URL}/api/1/clients/numbers/validate`, {
      number,
      code
    })
  )?.data?.number
  if(!result) {
    throw new Error('Invalid Pin')
  }

}

const updateClient = async (clientId, {
  first_name,
  last_name,
  email,
  mobile_number,
  birthday,
  gender
}) => {
  const result = (
    await axios.put(`${API_URL}/api/1/clients/${clientId}`, filterNonNull({
      first_name,
      last_name,
      email,
      mobile_number,
      birthday,
      gender
    })))?.data

  let usr = JSON.parse(localStorage.getItem('user'))
  usr = usr?.client?.id ? { ...usr, client: result } : { ...usr, user: result }
  await localStorage.setItem('user', JSON.stringify(usr))
  return result
}

const createOrUpdatePersonalInfo = async(clientId, {
  first_name,
  last_name,
  gender,
  birthday,
}) => {
  const result = (
    await axios.post(`${API_URL}/api/1/personal_infos/${clientId}/update`, {
      first_name,
      last_name,
      gender,
      birthday,
    }))?.data
  let usr = JSON.parse(localStorage.getItem('user'))
  usr = {
    ...usr,
    personalInfo: result
  }
  await localStorage.setItem('user', JSON.stringify(usr))
  return result
}

const updateClientProfile = async (profileId, {
  first_name,
  last_name,
  gender,
  birthday,
}) => {
  const result = (
    await axios.post(`${API_URL}/api/1/personal_infos/${profileId}/update`, {
      first_name,
      last_name,
      gender,
      birthday,
    }))?.data
  let usr = JSON.parse(localStorage.getItem('user'))
  usr = {
    ...usr,
    personalInfo: result
  }
  await localStorage.setItem('user', JSON.stringify(usr))
  return result
}

const isAuthenticated = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  return !!user?.token
}

export {
  updateClientProfile,
  updateClient,
  clientRegister,
  validateMobilePhoneNumber,
  requestMobileNumberValidationCode,
  isAuthenticated,
  clientLogin,
  testLogEventWhitelabel,
  useUserState,
  requestPinCode,
  requestWhitelabelVerification,
  requestWhitelabelCustomerValidation,
  createOrUpdatePersonalInfo
};
